import api, { apiCognito } from "./api";
import apiOSS from "./apiOSS";

export function setAuthTokenHeaders(token: string) {
  const value = "Bearer " + token;
  api.defaults.headers.common["Authorization"] = value;
  apiCognito.defaults.headers.common["Authorization"] = value;
  apiOSS.defaults.headers.common["Authorization"] = value;
}
